export const JIRA_DETAILS_OPEN_MODAL = "JIRA_DETAILS_OPEN_MODAL";
export const JIRA_SEARCH_DETAILS_REQUEST = "JIRA_SEARCH_DETAILS_REQUEST";
export const JIRA_SEARCH_DETAILS_RESULT = "JIRA_SEARCH_DETAILS_RESULT";
